import {indiceDiagnosticos,buscarDiagnosticos} from './diagnosticoSearch';
import React, { useMemo, useState } from 'react';
import { Autocomplete, Box, Typography, Chip, TextField } from '@mui/material';

export const buscarDiagnostico = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
export const separarDiagnosticos = value => {
  const unicos = new Map();
  for (const item of (Array.isArray(value) ? value : [value])) {
    for (const parte of String(item || '').split(';')) {
      const texto = parte.trim().replace(/\s+/g, ' ').toLocaleUpperCase('es-PE');
      const clave = buscarDiagnostico(texto);
      if (clave && !unicos.has(clave)) unicos.set(clave, texto);
    }
  }
  return [...unicos.values()];
};
export const guardarDiagnosticos = values => separarDiagnosticos(values).join('; ');

export default function DiagnosticosSelector({ value, onChange, sugerencias = [], placeholder }) {
  const seleccionados = useMemo(() => separarDiagnosticos(value), [value]);
  const opciones = useMemo(() => separarDiagnosticos(sugerencias), [sugerencias]);
  const [query,setQuery]=useState('');
  const index=useMemo(()=>indiceDiagnosticos(opciones),[opciones]);
  const matches=useMemo(()=>buscarDiagnosticos(index,query).filter(r=>!seleccionados.some(v=>buscarDiagnostico(v)===buscarDiagnostico(r.text))),[index,query,seleccionados]);
  const exact=opciones.some(v=>buscarDiagnostico(v)===buscarDiagnostico(query))||seleccionados.some(v=>buscarDiagnostico(v)===buscarDiagnostico(query));
  const results=query.trim()&&!exact?[...matches,{text:query.trim().toLocaleUpperCase('es-PE'),nuevo:true}]:matches;
  const textOf=option=>typeof option==='string'?option:option.text;
  return <Autocomplete multiple autoHighlight={false} autoSelect={false} disableCloseOnSelect filterSelectedOptions
    value={seleccionados} options={results} inputValue={query}
    onInputChange={(_,text,reason)=>{if(reason!=='blur')setQuery(text);}}
    getOptionLabel={textOf}
    isOptionEqualToValue={(a,b)=>buscarDiagnostico(textOf(a))===buscarDiagnostico(textOf(b))}
    filterOptions={lista=>lista}
    onChange={(_,next)=>{onChange(guardarDiagnosticos(next.map(textOf)));setQuery('');}}
    renderOption={(props,option)=>{const {key,...rest}=props;return <li {...rest} key={option.text}><Box sx={{py:.5}}><Typography sx={{fontSize:12,fontWeight:600}}>{option.nuevo?'Ingresar nuevo: '+option.text:option.text}</Typography>{(option.similar||option.nuevo)&&<Typography sx={{fontSize:11,color:'#73839a'}}>{option.nuevo?'Revisa las coincidencias antes de crear uno nuevo.':'Diagnóstico similar · revisa antes de seleccionar'}</Typography>}</Box></li>;}}
    renderTags={(values,getTagProps)=>values.map((diagnostico,index)=>{
      const {key,...props}=getTagProps({index});
      return <Chip {...props} key={diagnostico} label={diagnostico} size="small" title={diagnostico}
        sx={{maxWidth:'100%',height:'auto',minHeight:27,borderRadius:'8px',bgcolor:'#EDF3FB',color:'#375D87',fontSize:11,fontWeight:600,'& .MuiChip-label':{whiteSpace:'normal',overflowWrap:'anywhere',py:.6},'& .MuiChip-deleteIcon':{fontSize:16,color:'#7791B2'}}}/>;
    })}
    renderInput={params=><TextField {...params} placeholder={seleccionados.length?'Añadir diagnóstico…':placeholder || 'Buscar o escribir diagnóstico…'} size="small"
      helperText="Busca incluso con errores de escritura. Selecciona una coincidencia o elige «Ingresar nuevo»."
      FormHelperTextProps={{sx:{fontSize:10,lineHeight:1.4,mx:.3}}}
      inputProps={{...params.inputProps,'aria-label':'Diagnósticos',spellCheck:true,lang:'es-PE',autoCapitalize:'sentences'}}/>}
    componentsProps={{paper:{sx:{borderRadius:'16px',border:'1px solid #E6ECF3',boxShadow:'0 12px 36px #283e5d20',fontSize:12}}}}
  />;
}

